// Lucide icon: store (https://lucide.dev/icons/store)
import { Store } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconVendor = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Store />
    </IconComponentStyled>
  )
}
